const invertedMessages = {
  // The “Other” label is not translated because the check is mandatory to display the “Other” option to the user.
  // Other: 'certs.comment.other',
  'Comment is required': 'certs.comment.required',
  'Your comments must contain more than 2 characters.':
    'certs.comment.minlength',
  'Quick comments': 'certs.predefined.comment.title',
  'Select a predefined comment or choose “Other” to enter your own.':
    'certs.predefined.comment.palceholder',
  'Provide a reason for your decision': 'CERTS_TERMINATE_PLACEHOLDER',
  'Select a pre-defined comment': 'certs.only.predefined.comment.palceholder',
};

export default invertedMessages;
